<template>
    <div class="card">
        <div class="card-content">
        <p class="title">{{ movieData.row.Full_title }}</p>
        <p class="subtitle">di {{ movieData.directors_string }}</p>
        <p class="subtitle">{{movieData.genre_string}}, {{movieData.tmdb.runtime}}'</p>
        <div class="media">
            <div class="media-left">
            <figure class="image" width="50%">
                <img
                :src="
                    'http://image.tmdb.org/t/p/w185/' +
                    movieData.tmdb.poster_path
                "
                alt="Poster"
                />
            </figure>
            </div>

            <div class="media-content">
            <p v-if="movieData.tmdb.tagline" class="subtitle">{{movieData.tmdb.tagline}} </p>
            <p>{{movieData.tmdb.overview}}</p>

            <p><i>Visto il {{movieData.row.Date_seen}}, {{movieData.row.Full_mode_desc}} {{movieData.friend_string}}</i></p> <br/>
            <p><i>{{movieData.tag_string }}</i></p>  
            <p>{{movieData.row.Comment}}                         <star-rating
                    v-model="movieData.row.Dicks"
                    :show-rating="false"
                    :read-only="true"
                    :increment="0.5"
                    :star-size="30"
                  /></p>
            </div>
        </div>
        </div>
        <footer class="card-footer">
        <a href="#" @click="doEdit" class="card-footer-item">Edit</a>
        <a href="#" @click="doDelete" class="card-footer-item">Scancellalo!</a>
        <a :href="'https://www.imdb.com/title/'+movieData.tmdb.imdb_id" target="_blank" class="card-footer-item">Imdb</a>
        <a href="#" @click= "doAsinello" class="card-footer-item">Asinello</a>
        <a href="#" @click= "doClose" class="card-footer-item">Chiudi</a>
        </footer>
    </div>
</template>

<script>
import StarRating from "vue-star-rating";
export default {
  name: 'MovieDetails',
  methods: {
   doEdit() {
      this.$emit("MovieDetailsEdit"); 
   }  ,
   doDelete() {
      this.$emit("MovieDetailsDelete"); 
   },
   doAsinello() {
      this.$emit("MovieDetailsAsinello");
   },
   doClose() {
      this.$parent.close()
   } 
  },
  props: ['movieData'],
  components: {StarRating} ,

  data() {
    return {
    };
  },
  mounted() {
  }
};
</script>

